import { LDProvider, ProviderConfig } from 'launchdarkly-react-client-sdk';
import React, { useContext } from 'react';
import { AuthStore } from '../auth';
import { buildLDContext } from '../../util/launchdarkly.util';

export const FeatureProvider = ({ children }) => {
  const { state: authState } = useContext(AuthStore);

  // Don't instantiate if we don't have the auth and permissions data loaded yet
  if (!authState?.auth?.user) {
    return children;
  }

  const onboardingConfig: ProviderConfig = {
    clientSideID: process.env.REACT_APP_LAUNCHDARKLY_DEFAULT_CLIENT_ID || '',
    context: buildLDContext(authState.auth),
  };

  return <LDProvider {...onboardingConfig}>{children}</LDProvider>;
};
